module.exports = "/_next/static/images/wastewaterSolutions-079bbba2688dbf293bed934b54732a30.webp";